export default {"src":"/_next/static/media/metal-platinum.470fb726.svg","height":27,"width":32};